
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
import VueModalPopUp from '@/components/Common/VueModalPopUp.vue';
import { ChannelInfo } from '@/entities/Chat/ChannelInfo';
import { app } from '@/main';
import vClickOutside from 'click-outside-vue3';


@Component({
  components: {
    VueModalPopUp,
    vClickOutside,
  },
})
class ChatListing extends Vue {
  // Props passed from parent component
  @Prop() chatData!: ChannelInfo;
  // Local chat data (initialized with empty data)
  private localChat: ChannelInfo = ChannelInfo.createEmpty();
  // State to toggle the dropdown menu visibility
  private showMenu = false;
  private menuBarIcon = require('@/assets/Images/black-overflow-menu.svg');
  private  missingImage: string = require('@/assets/Images/group-icon.svg');

  // Called when the component is mounted
  private mounted() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    app.use(vClickOutside);
    this.localChat = this.chatData;
  }

  // Method to toggle the dropdown menu
  private toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  // Method to emit the edit event
  private editItem() {
    this.$emit('edit', this.localChat.Id); // Make sure chatData has an 'id' field
  }

  // Method to emit the delete event
  private deleteItem() {
    this.$emit('delete', this.localChat.Id); // Make sure chatData has an 'id' field
  }
  private GetImageUrl() {
    return this.localChat.Details.ImageUrl == null || this.localChat.Details.ImageUrl === ''
      ? this.missingImage
      : this.localChat.Details.ImageUrl;
  }
  @Watch('chatData', { immediate: true })
  private onChatDataChanged() {
    this.localChat = this.chatData;
  }
}

export default ChatListing;
